<div>
  <span *ngIf="error">{{ error }}</span>
  <ng-container [ngSwitch]="block.type">
    <ng-container *ngSwitchCase="'rich_text'">
      <ion-item>
        <app-slack-text-editor
          [content]="htmlStrings[0]"
          style="width: 100%"
          [isRichText]="true"
          (contentDidChange)="onHtmlContentChange($event)"
          [projectId]="project?.id ?? undefined"
          [enableSlackMentions]="true"
        >
        </app-slack-text-editor>
      </ion-item>
    </ng-container>
    <ng-container *ngSwitchCase="'section'">
      <ion-list class="slack-block-form">
        <ion-item height="20px">
          <app-slack-text-editor
            [content]="htmlStrings[0]"
            style="width: 100%"
            (contentDidChange)="onHtmlContentChange($event)"
            [projectId]="project?.id ?? undefined"
            [enableSlackMentions]="true"
          >
          </app-slack-text-editor>
          <ion-button
            color="light"
            *ngIf="block.accessory"
            slot="end"
            (click)="addImageAccessory()"
            class="section-image-accessory"
          >
            <ion-icon name="image-outline" class="padded-icon"></ion-icon>
            Choose photo
          </ion-button>
        </ion-item>
        <ion-item>
          <ion-button
            color="dark"
            fill="clear"
            class="button-dark-border"
            (click)="toggleImageAccessory()"
          >
            <ion-icon
              [name]="block.accessory ? 'checkmark-circle' : 'ellipse-outline'"
              class="padded-icon"
            ></ion-icon>
            Show accessory image
          </ion-button>
        </ion-item>
      </ion-list>
    </ng-container>

    <ng-container *ngSwitchCase="'actions'">
      <ion-card
        *ngFor="let button of block.elements; let i = index"
        class="outline-card"
      >
        <ion-list
          class="slack-block-form form-list"
          style="border-bottom: 1px solid var(--ion-color-step-100)"
        >
          <ion-item>
            <ion-label position="stacked"
              >Button label (max 30 characters)</ion-label
            >
            <ion-input
              [(ngModel)]="button.text.text"
              type="text"
              inputmode="url"
              [maxlength]="30"
              required
              (ngModelChange)="onChange()"
            ></ion-input>
          </ion-item>

          <ion-item>
            <ion-label position="stacked">Button Action</ion-label>
            <ion-select
              [(ngModel)]="button.actionType"
              (ngModelChange)="onButtonActionTypeChange(button)"
              interface="popover"
            >
              <ion-select-option value="url">Open URL</ion-select-option>
              <ion-select-option value="automation"
                >Run Automation</ion-select-option
              >
            </ion-select>
          </ion-item>

          <ion-item *ngIf="button.actionType === 'url'">
            <ion-label position="stacked">Link URL</ion-label>
            <ion-input
              [(ngModel)]="button.url"
              type="url"
              [maxlength]="3000"
              required
              (ngModelChange)="onChange()"
            ></ion-input>
          </ion-item>

          <ion-item *ngIf="button.actionType === 'automation'">
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              (click)="selectAutomation(button)"
            >
              {{
                button.automationId
                  ? button.automationName
                  : "Select an automation"
              }}
              <ion-icon
                name="caret-down-outline"
                class="button-icon"
                style="margin: 0 1px 0 4px"
              ></ion-icon>
            </ion-chip>
          </ion-item>

          <ion-item *ngIf="button.actionType === 'automation'">
            <ion-label position="stacked">On submit</ion-label>
            <ion-select
              [(ngModel)]="button.automationOnSubmitAction"
              (ngModelChange)="onChange()"
              interface="popover"
              [compareWith]="genericCompareFn"
            >
              <ion-select-option [value]="null">Do nothing</ion-select-option>
              <ion-select-option value="removeButton"
                >Remove the button</ion-select-option
              >
              <ion-select-option value="removeBlock"
                >Remove the entire block</ion-select-option
              >
              <ion-select-option value="replaceBlock"
                >Replace the block with a template</ion-select-option
              >
            </ion-select>
          </ion-item>

          <ion-item
            *ngIf="
              button.actionType === 'automation' &&
              button.automationOnSubmitAction === 'replaceBlock'
            "
          >
            <ion-chip
              mode="ios"
              class="select-chip select-outline no-margin"
              [outline]="true"
              (click)="selectTemplate(button)"
            >
              {{
                button.automationReplacementTemplateId
                  ? button.automationReplacementTemplateName
                  : "Select a template"
              }}
              <ion-icon
                name="caret-down-outline"
                class="button-icon"
                style="margin: 0 1px 0 4px"
              ></ion-icon>
            </ion-chip>
          </ion-item>

          <ion-item>
            <div slot="start">
              <ion-button
                fill="clear"
                color="dark"
                [disabled]="true"
                class="btn-xs"
              >
                Style:
              </ion-button>
              <ion-button
                fill="clear"
                color="dark"
                (click)="setButtonStyle(button, 'default')"
                class="btn-xs"
                [ngClass]="{
                  'pill-button-active':
                    !button.style || button.style === 'default'
                }"
              >
                Default
              </ion-button>
              <ion-button
                fill="clear"
                color="dark"
                (click)="setButtonStyle(button, 'primary')"
                class="btn-xs"
                [ngClass]="{ 'pill-button-active': button.style === 'primary' }"
              >
                Green
              </ion-button>
              <ion-button
                fill="clear"
                color="dark"
                (click)="setButtonStyle(button, 'danger')"
                class="btn-xs"
                [ngClass]="{ 'pill-button-active': button.style === 'danger' }"
              >
                Red
              </ion-button>
            </div>
            <ion-button
              slot="end"
              color="light"
              class="btn-xs"
              *ngIf="block.elements.length > 1"
              (click)="removeElement(i)"
            >
              Remove
            </ion-button>
          </ion-item>
        </ion-list>
      </ion-card>
      <div class="block-actions">
        <ion-button
          expand="block"
          color="dark"
          fill="clear"
          (click)="addButtonElement()"
        >
          <ion-icon name="add-outline" slot="start"></ion-icon>
          Add Button
        </ion-button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'image'">
      <ion-list class="slack-block-form">
        <!-- <ion-item>
          <ion-label position="stacked">URL</ion-label>
          <ion-input [(ngModel)]="block.image_url" type="url" inputmode="url" [maxlength]="3000" required></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Alt text</ion-label>
          <ion-input [(ngModel)]="block.alt_text" type="text" [maxlength]="2000" required></ion-input>
        </ion-item> -->
        <ion-item>
          <ion-button (click)="addImageAccessory()" color="light">
            Upload image
          </ion-button>
          <ion-button (click)="addGif()" color="light">
            Choose a GIF
          </ion-button>
        </ion-item>
      </ion-list>
    </ng-container>

    <ng-container *ngSwitchCase="'divider'"></ng-container>

    <ng-container *ngSwitchCase="'header'">
      <ion-list class="slack-block-form">
        <ion-item>
          <ion-label position="stacked">Text</ion-label>
          <ion-input
            [(ngModel)]="block.text.text"
            type="text"
            [maxlength]="150"
            (ngModelChange)="onChange()"
            required
          ></ion-input>
        </ion-item>
      </ion-list>
    </ng-container>

    <ng-container *ngSwitchCase="'context'">
      <ion-list class="slack-block-form">
        <div *ngFor="let element of block.elements; let i = index">
          <ion-card-header style="padding-top: 5px; padding-bottom: 5px">
            <div class="flex-space-between">
              <div class="flexed-align-center">
                <strong>{{ getElementTitle(element) }}</strong>
              </div>
              <span>
                <ion-button
                  fill="clear"
                  (click)="removeElement(i)"
                  *ngIf="block.elements.length > 1"
                >
                  <ion-icon name="trash-outline"></ion-icon>
                </ion-button>
              </span>
            </div>
          </ion-card-header>
          <div>
            <ion-list class="slack-block-form">
              <ng-container *ngIf="element.type === 'image'">
                <ion-item>
                  <ion-label position="stacked">URL</ion-label>
                  <ion-input
                    [(ngModel)]="element.image_url"
                    type="url"
                    inputmode="url"
                    [maxlength]="3000"
                    required
                    (ngModelChange)="onChange()"
                  >
                  </ion-input>
                </ion-item>
                <ion-item>
                  <ion-label position="stacked">Alt text</ion-label>
                  <ion-input
                    [(ngModel)]="element.alt_text"
                    type="text"
                    [maxlength]="2000"
                    required
                    (ngModelChange)="onChange()"
                  ></ion-input>
                </ion-item>
              </ng-container>
              <ng-container *ngIf="element.type !== 'image'">
                <ion-item>
                  <app-slack-text-editor
                    [content]="htmlStrings[i]"
                    style="width: 100%"
                    (contentDidChange)="onContextTextElementChange(i, $event)"
                    [projectId]="project?.id ?? undefined"
                    [enableSlackMentions]="true"
                  >
                  </app-slack-text-editor>
                </ion-item>
              </ng-container>
            </ion-list>
          </div>
        </div>
        <ion-item>
          <ion-button color="light" (click)="addTextElement()">
            + Add text
          </ion-button>
        </ion-item>
      </ion-list>
    </ng-container>

    <ng-container *ngSwitchCase="'survey'">
      <ion-list class="slack-block-form">
        <ion-item [disabled]="true">
          <ion-label position="stacked">Survey type</ion-label>
          <span *ngIf="block.survey.type === 'nps'"> NPS score </span>
          <span *ngIf="block.survey.type === 'csat'"> CSAT score </span>
        </ion-item>
        <ion-item
          [hidden]="block.survey.buttonLayout === 'inline'"
          [disabled]="true"
        >
          <ion-label position="stacked">Button label</ion-label>
          <ion-input
            [(ngModel)]="block.survey.buttonLabel"
            type="text"
            [maxlength]="2000"
            required
            [disabled]="block.survey_id || block.survey?.id"
          ></ion-input>
        </ion-item>
        <ion-item [disabled]="true">
          <ion-label position="stacked">Message after submission</ion-label>
          <ion-input
            [(ngModel)]="block.survey.postSubmissionMessage"
            type="text"
            [maxlength]="2000"
            required
            [disabled]="block.survey_id || block.survey?.id"
          ></ion-input>
        </ion-item>
        <ion-item>
          <ion-button
            (click)="viewSurveyPreview(block)"
            [hidden]="block.survey.buttonLayout === 'inline'"
          >
            View pop-up preview
            <ion-icon name="open-outline" class="icon-padded-left"></ion-icon>
          </ion-button>
          <ion-button
            (click)="editSurvey(block.survey_id ?? block.survey?.id)"
            *ngIf="block.survey_id || block.survey?.id"
            fill="clear"
            color="dark"
            class="button-dark-border"
          >
            Edit survey
          </ion-button>
        </ion-item>
      </ion-list>
    </ng-container>
  </ng-container>
</div>
